import { render, staticRenderFns } from "./fenXi.vue?vue&type=template&id=3d3735af&scoped=true"
import script from "./fenXi.vue?vue&type=script&lang=js"
export * from "./fenXi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3735af",
  null
  
)

export default component.exports